import { DOCXPreview, PDFPreview } from "../../../../../components"

import { useTranslation } from "react-i18next"

const buildPdfUrl = (src) =>
  src.includes("#")
    ? `${src}&toolbar=0&navpanes=0&view=FitH`
    : `${src}#toolbar=0&navpanes=0&view=FitH`

const buildDocxUrl = (src) => {
  // Use Google Docs Viewer for DOCX files
  return `https://docs.google.com/gview?url=${encodeURIComponent(
    src
  )}&embedded=true`
}

const DesktopColumns = ({ document, onCloseDocument, leftPane }) => {
  const { t } = useTranslation()
  const pdfUrl =
    document?.storageUrl &&
    /\.pdf(\?|$)/i.test(document.storageUrl || document?.fileName || "")
      ? buildPdfUrl(document.storageUrl)
      : null

  const docxUrl =
    document?.storageUrl &&
    /\.docx?(\?|$)/i.test(document.storageUrl || document?.fileName || "")
      ? buildDocxUrl(document.storageUrl)
      : null

  return (
    <div className="w-full h-full px-6 pb-8 flex gap-14 ">
      {/* Left */}
      <div className="w-1/2 h-full min-w-0 flex flex-col relative z-[40]">
        <div className="flex-1 min-h-0 overflow-hidden">{leftPane}</div>
      </div>

      {/* Right */}
      <div className="w-1/2 h-full min-w-0 flex flex-col relative z-[10]">
        <div className="flex-1 min-h-0 bg-[#121212] rounded-[28px] shadow-lg overflow-hidden flex flex-col">
          {" "}
          {/* Header */}
          <div className="px-5 pb-3 pt-4 flex items-center justify-between text-white/90">
            <h1
              className="text-light-default font-bold"
              style={{ fontSize: 36 }}
            >
              The contract
            </h1>
            <button
              onClick={onCloseDocument}
              className="w-8 h-8 rounded-full flex items-center justify-center"
              aria-label="Close"
            >
              <span className="leading-none" style={{ fontSize: 42 }}>
                ×
              </span>
            </button>
          </div>
          {/* Viewer */}
          <div className="p-3 h-full">
            <div
              className="
          w-full rounded-2xl overflow-hidden bg-white h-full
        "
            >
              {document?.storageUrl ? (
                pdfUrl ? (
                  <object
                    key={pdfUrl}
                    data={pdfUrl}
                    type="application/pdf"
                    className="w-full h-full bg-white"
                  >
                    <iframe
                      key={pdfUrl}
                      title="PDF"
                      src={pdfUrl}
                      className="w-full h-full bg-white"
                    />
                  </object>
                ) : docxUrl ? (
                  <iframe
                    key={docxUrl}
                    title="DOCX"
                    src={docxUrl}
                    className="w-full h-full bg-white"
                    style={{ border: "none" }}
                  />
                ) : (
                  <div className="w-full h-[min(74vh,680px)] rounded-3xl overflow-hidden bg-white">
                    <div className="h-full overflow-auto">
                      {document?.type === "application/pdf" ? (
                        <PDFPreview file={document} embed />
                      ) : (
                        <DOCXPreview file={document} embed />
                      )}
                    </div>
                  </div>
                )
              ) : (
                <div className="w-full h-full rounded-3xl overflow-hidden bg-white">
                  <div className="h-full overflow-auto">
                    {document?.type === "application/pdf" ? (
                      <PDFPreview file={document} embed />
                    ) : (
                      <DOCXPreview file={document} embed />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopColumns
